<ng-container *ngIf="orderEntry$ | async as orderEntry">
  <ng-container *ngIf="isAttributeBasedConfigurator(orderEntry)">
    <div *ngIf="hasStatus(orderEntry)" class="udex-mb-20 udex-mt-8">
      <div class="cx-configuration-info udex-mb-8" *ngFor="let info of orderEntry.configurationInfos">
        <div class="cx-label body--s">{{ info?.configurationLabel }}:</div>
        <div class="cx-value heading__medium--xxxxs" [innerHtml]="info?.configurationValue"></div>
      </div>
    </div>

    <cx-configure-cart-entry
      *ngIf="
        ((shouldShowButton$ | async) ?? false) &&
        orderEntry?.product?.configurable &&
        ((quantityControl$ | async) ?? false) as quantityControl
      "
      [cartEntry]="orderEntry"
      [readOnly]="(readonly$ | async) ?? false"
      [msgBanner]="false"
      [disabled]="quantityControl.disabled"
      class="body--s"></cx-configure-cart-entry>
  </ng-container>
</ng-container>
